import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import { FiHome } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export const LoginPage: React.FC = () => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const result = await login(id, password);

    if (result.success && result.user) {
      toast.success('로그인 성공!');
      // 레벨에 따라 다른 페이지로 이동
      if (result.user.level === 1) {
        navigate('/admin');  // 관리자: 현황
      } else {
        navigate('/my');     // 매니저/스태프: 내청소
      }
    } else {
      setError(result.message || '로그인에 실패했습니다.');
    }

    setIsLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo">
            <FiHome />
          </div>
          <h1 className="login-title">모두스테이</h1>
          <p className="login-subtitle">청소관리 시스템</p>
        </div>

        <div className="login-form">
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Floating className="mb-3">
            <Form.Control
              type="text"
              id="userId"
              placeholder="아이디"
              value={id}
              onChange={(e) => setId(e.target.value)}
              required
              autoComplete="username"
            />
            <label htmlFor="userId">아이디</label>
          </Form.Floating>

          <Form.Floating className="mb-4">
            <Form.Control
              type="password"
              id="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <label htmlFor="password">비밀번호</label>
          </Form.Floating>

          <Button
            variant="primary"
            type="submit"
            className="w-100"
            disabled={isLoading}
          >
            {isLoading ? '로그인 중...' : '로그인'}
          </Button>
        </Form>

        <div className="text-center mt-3">
          <Link to="/register" className="text-decoration-none">
            회원가입
          </Link>
        </div>
        </div>
      </div>
    </div>
  );
};
